import React from "react";
import { Navigate } from "react-router-dom";

const AuthProtected = (props) => {
  let authToken = localStorage.getItem("authUser") as string
  if (!authToken) {
    return (
      <Navigate to={{ pathname: "/country-section" }} />
    );
  }
  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default AuthProtected;
